// extracted by mini-css-extract-plugin
export default {"errorBanner":"EhFNfh","slideIn":"xjWRjM","content":"pbOk7N","icon":"jyd2Id","text":"qcLLXW","tryAgainButton":"U8Bm9f","closeButton":"oZ4A_D"};